/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { flyoutIcons } from '../../Flyout/_icons';

import { IconEnum } from '../../../data/MenuItem';

import IconComponent from '../../Icon';

import MobileFlyoutDropdownMenu from '../MobileFlyoutDropdownMenu';

import { MobileFlyoutMegaMenuButtonProps } from './_props';

import useMobileFlyoutMegaMenuTheme from './themes';

/**
 * MobileFlyoutMegaMenuButton Component
 */

function MobileFlyoutMegaMenuButton({ subMenuMainItem }: MobileFlyoutMegaMenuButtonProps) {
  const { megaMenuButtonClasses, megaMenuButtonTextClasses, megaMenuIconProps, ChevronRightIcon } =
    useMobileFlyoutMegaMenuTheme();

  return (
    <div className="flex flex-col gap-4">
      <a href={subMenuMainItem.path} type="button" className={megaMenuButtonClasses}>
        {flyoutIcons.get(IconEnum.BairesDev)}

        <p className={megaMenuButtonTextClasses}> {subMenuMainItem.label} </p>

        <IconComponent Icon={ChevronRightIcon} {...megaMenuIconProps} />
      </a>

      <MobileFlyoutDropdownMenu mobileMenuActiveItem={subMenuMainItem.id} subMenuItem={subMenuMainItem} hasIcon />
    </div>
  );
}

/**
 * Exports
 */

export default MobileFlyoutMegaMenuButton;
